module.exports = __webpack_public_path__ + "img/yxlctj.78e34889.png";